import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import termsText from "../data/merchCopyTerms.json";

export const COPY_SLUG = "ford-event-a1-game-merch";
export const COPY_TERMS_PATH = "/ford-event-a1-game-merch-terms";
export const COPY_COLLECTION = "ford-event-game-merch-new-requests";
export const defaults = {
  name: "Ford Event Game — раница, тениска и шапка",
  eventDate: "2026-09-18",
  eventLabel: "18-20 септември 2026 г.",
  termsTitle: "Играй и участвай в томбола за награда от Ford!",
  termsText: termsText.replaceAll("https://sale.ford.bg/landing/ford-event-game-merch", `https://sale.ford.bg/landing/${COPY_SLUG}`),
  registrationEnabled: false,
  weekendTestDrivePrize: false,
};
const campaignRef = () => doc(db, "GameCampaigns", "ford-event-game-merch-new");
export async function loadMerchCopy() {
  const snapshot = await getDoc(campaignRef());
  return { ...defaults, ...(snapshot.exists() ? snapshot.data() : {}) };
}
export async function saveMerchCopy(value) {
  const data = Object.fromEntries(Object.keys(defaults).map(key => [key, value[key]]));
  if (!["name", "eventDate", "eventLabel", "termsTitle", "termsText"].every(key => typeof data[key] === "string" && data[key].trim())) {
    throw new Error("Попълнете всички полета.");
  }
  if (typeof data.registrationEnabled !== "boolean" || data.termsText.length > 200000) {
    throw new Error("Проверете настройките и дължината на условията.");
  }
  await setDoc(campaignRef(), { ...data, updatedAt: serverTimestamp() });
}
